export default __webpack_public_path__ + "static/DIGITAL_HOUSE-56ae4d5e22a1474fa1a3ea955f38520d.svg";